<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Calendar</h5>
        </div>
        <div class="col-8 col-sm-6 text-right" v-if="pagepermission.insertable">
          <div class="d-inline-flex mr-2">
            <bulk-upload-student />
          </div>
          <div class="d-inline-flex mr-2">
            <a href="javascript:;" class="btn btn-sm btn-success btn-with-addon"
              @click="showCalendar"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-calendar" />
              </span>
              Calendar
            </a>
          </div>
          <div class="d-inline-flex">
            <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon"
              @click="showEventAddModal"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-plus-circle" />
              </span>
              Event
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="pagepermission.viewable">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <Events :rolesetting="pagepermission"/>
          </div>
        </div>
      </div>
      <a-modal v-model="visible" title="Calendar" :width="this.settings['isMobileView'] ? 480 : this.settings['isTabletView'] ? 720 : 1080" style="top: 20px;" @cancel="handleCancel">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
        </template>
        <calendar-view :rolesetting="pagepermission" ref="displayCalendar"/>
      </a-modal>
      <!-- <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <calendar-view ref="displayCalendar"/>
          </div>
        </div>
      </div> -->
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import CalendarView from '@/components/calendar/Display/index'
import Events from '@/components/calendar/Events/index'
import BulkUploadStudent from '@/components/calendar/Form/Bulk'

export default {
  components: {
    CalendarView,
    Events,
    BulkUploadStudent,
  },
  beforeMount: function () {
    let rc = this.$roleutility.checkpermission('calendar', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
  },
  data: function() {
    return {
      visible: false,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    handleRefresh: function() {
      this.$refs.displayCalendar.getCalendarData()
      this.$eventBus.$emit('calendarEventUpdated')
    },
    showEventAddModal () {
      this.$eventBus.$emit('openCalendarEventAddModal', moment())
    },
    showCalendar() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
